import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PaymentSuccessPage } from './payment-success.page';
import { SharedModuleModule } from '../../shared-module/shared-module.module';
import { RequestEmailComponent } from './request-email/request-email.component';
import { FailLoadingReceiptComponent } from './fail-loading-receipt/fail-loading-receipt.component';
import { AwaitNotificationModalComponent } from './await-notification-modal/await-notification-modal.component';

const routes: Routes = [
	{
		path: '',
		component: PaymentSuccessPage,
	},
];

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes), SharedModuleModule],
	declarations: [
		PaymentSuccessPage,
		RequestEmailComponent,
		FailLoadingReceiptComponent,
		AwaitNotificationModalComponent,
	],
})
export class SuccessPageModule {}
